module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Super_Script.db5a3fe4.svg";